export default "__VITE_ASSET__5f04222f__"